import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PatientCreate, PatientCreateSchema } from '@schema/patient';
import AddPatientForm from '@patientMenu/form/AddPatientForm';
import { ModalFormWrapper } from '@/components/ui/ModalFormWrapper';
import { useParams } from 'react-router-dom';
import { usePatient } from '@hooks/usePatient';
import { useUpdatePatient } from '@hooks/usePatient';
import { useEffect } from 'react';

interface EditPatientProps {
  onClose: () => void;
}

export function EditPatient({ onClose }: EditPatientProps) {
  useDocumentTitle("Patients - Edit | fullName");
  const { patientId } = useParams<{ patientId: string }>();
  const patientQuery = usePatient(patientId!);
  const patientMut = useUpdatePatient(patientId!);

  const form = useForm<PatientCreate>({
    resolver: zodResolver(PatientCreateSchema),
  });

  const onSubmit = (data: PatientCreate) => {
    patientMut.mutate(data, {
      onSuccess: () => {
        form.reset();
        onClose();
      },
      onError: (error) => {
        console.error('Error updating patient:', error);
      },
    });
  };

  useEffect(() => {
    if (patientQuery.data) {
      form.reset({
        ...patientQuery.data,
      });
    }
  }, [patientQuery.data, form]);

  if (patientQuery.isLoading) {
    return null;
  }

  return (
    <ModalFormWrapper form={form} submitText="Submit" submitButton="default" onSubmit={onSubmit} onClose={onClose}>
      <AddPatientForm />
    </ModalFormWrapper>
  );
}
